import React from 'react';

class Spells extends React.Component{
    render(){
        const {spell,type,effect}= this.props
        return(
                <div className="cf">
                    <div className="fl w-third tc pv5 mt4 ">
                        {spell}
                    </div>
                    <div className="fl w-third tc pv5 mt4 ">
                        {type}
                    </div>
                    <div className="fl w-third tc pv5 mt4 ">
                        {effect}
                    </div>
                </div>
        )
    }
}

export default Spells